import { render, staticRenderFns } from "./ent-logistics-select.vue?vue&type=template&id=2b6b21bf&"
import script from "./ent-logistics-select.vue?vue&type=script&lang=js&"
export * from "./ent-logistics-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports